import React, { useEffect } from "react";
import { useAccountSelector, useReportsSelector, useUserSelector } from "store";
import { Userpilot } from "userpilot";

interface UserpilotProviderProps {
  children: React.ReactNode;
}

export const UserpilotProvider: React.FC<UserpilotProviderProps> = ({ children }): JSX.Element => {
  const user = useUserSelector();
  const account = useAccountSelector();
  const reportsStatus = useReportsSelector();
  // const enabledAccounts =
  //   process.env.REACT_APP_ENABLED_ACCOUNTS_USERPILOT?.split(",");
  useEffect(() => {
    if (
      (account && import.meta.env.REACT_APP_NODE_ENV === "production") ||
      (account && import.meta.env.REACT_APP_NODE_ENV === "staging") ||
      (account && import.meta.env.REACT_APP_NODE_ENV === "rc")
    ) {
      Userpilot.initialize("NX-059af331");
    }
  }, [account]);

  const fictiveEmail = `user_${user.id}@${account?.name}.capital`;
  useEffect(() => {
    if (user.id) {
      Userpilot.identify(`${user.id}`, {
        name: user.id,
        email: fictiveEmail,
        created_at: user.created_at,
        role: user.role.name,
        feature_list: {
          reports: reportsStatus
        },
        company: {
          id: account?.id,
          name: account?.name
        }
      });
    }
  }, [user, reportsStatus, fictiveEmail]);

  return <>{children}</>;
};
